import { CommonModule, NgIf, NgClass } from '@angular/common';
import { Component, Inject, OnInit, ViewChild, ViewEncapsulation , inject} from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FuseAlertComponent } from '@fuse/components/alert';
import { Alert } from 'app/models/alert';
import { CreateFolder, Asset } from 'app/models/document';
import { Util } from 'app/models/util';
import { DocumentService } from 'app/services/document.service';
import { QuillEditorComponent, QuillModule } from 'ngx-quill';
import { FileManagerListComponent } from '../../list/list.component';
import {MatSnackBar, MatSnackBarModule} from '@angular/material/snack-bar'; 
import { EventService } from 'app/services/event.service';
import { BrowserModule } from '@angular/platform-browser';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-upload-modal',
  standalone: true,
  templateUrl: './upload-modal.component.html',
  styleUrl: './upload-modal.component.scss',
  imports      : [
    MatButtonModule, 
    MatIconModule, 
    CommonModule,
    QuillModule, 
    FormsModule, 
    ReactiveFormsModule, 
    MatFormFieldModule, 
    MatInputModule, 
    NgIf, 
    NgClass,
    QuillEditorComponent,  
    MatSnackBarModule, 
    MatProgressSpinnerModule
],
})
export class UploadModalComponent {

    createFolderForm: UntypedFormGroup;
    folder : CreateFolder = new CreateFolder();
    alert : Alert = new Alert();

    showAlert : boolean = false;

    /**
     * Constructor
     */
    constructor(
        public matDialogRef: MatDialogRef<UploadModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private _formBuilder: UntypedFormBuilder,
        public docService : DocumentService,
        public util : Util,
        public  eventSer : EventService,
        private toastr: ToastrService,
      //  public _fileManagerComponent: FileManagerListComponent,
    )
    {
    }


    ngOnInit(): void
    {
        // Create the form
        this.createFolderForm = this._formBuilder.group({
           folderName: ['', [Validators.required]],
        //    description   : [''],
        });
    }

    getEditorToolbar(){
        return Util.getEditorToolbarOptions();
    }

   
    saveAndClose(): void {
        if (this.createFolderForm.invalid) return;
        this.createFolderForm.disable();
        const folderId = this.data.routeFolderId
        if (folderId) {
            this.createChildFolder(folderId)
        }
        else
            this.createFolder();
    }

    /**
     * Discard the action
     */
    cancel(): void
    {
        // Close the dialog
        this.matDialogRef.close();
    }
    /**
     * Create folder
     */
    
    public createFolder() {
        this.docService.createFolder(this.folder).then((res) => {
            this.folder = this.docService.getData(res);
            this.createFolderForm.enable();
            this.toastr.success("Folder created successfully");
            this.eventSer.getData.emit(true);
            this.matDialogRef.close();
            // this.toastr.success('Folder Created Successfully', "SUCCESS");
        }).catch((error)=>{
            console.log(error);
        })
    }
    public createChildFolder(folderId: string) {
        this.docService.createChildFolder(this.folder, folderId).then((res) => {
            this.folder = this.docService.getData(res);
            this.createFolderForm.enable();
            this.eventSer.getData.emit(true);
            this.toastr.success("Folder created successfully");
            this.matDialogRef.close();
        }).catch((error)=>{
            console.log(error);
        })
    }
}